import { render } from "./AdminSiteSettings.vue?vue&type=template&id=4f5a25b2&scoped=true"
import script from "./AdminSiteSettings.vue?vue&type=script&lang=js"
export * from "./AdminSiteSettings.vue?vue&type=script&lang=js"

import "./AdminSiteSettings.vue?vue&type=style&index=0&id=4f5a25b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5a25b2"]])

export default __exports__